import NewAwardPage from './NewAwardPage';
export default NewAwardPage;
